import { render, staticRenderFns } from "./UsageScoreCardWidget.vue?vue&type=template&id=615bddde&scoped=true"
import script from "./UsageScoreCardWidget.vue?vue&type=script&lang=js"
export * from "./UsageScoreCardWidget.vue?vue&type=script&lang=js"
import style0 from "./UsageScoreCardWidget.vue?vue&type=style&index=0&id=615bddde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615bddde",
  null
  
)

export default component.exports